<template>
<div class="text-left dashside">
    
    <h3 class="ml-3 navbody">Admin Functions</h3>
    
    <b-button v-b-toggle.admin-nav variant="outline-primary" class="sbb m-3">
        <b-icon-text-left font-scale="2"></b-icon-text-left>
    </b-button>

    <div class="link-nav">
      <b-sidebar title="Admin Functions" id="admin-nav" shadow>
          <template #default="clearance">
              <adminNavLinks class="link-nav" :clearance="clearance" :level="level" navbody="''"></adminNavLinks>
          </template>
          
      </b-sidebar>
    </div>
    
    <div class="link-nav">
      <adminNavLinks :clearance="clearance" :level="level" navbody="navbody"></adminNavLinks>
    </div>
    
</div>
</template>

<script>
import adminNavLinks from "@/components/admin/adminNavLinks"

export default {
    components : {
      adminNavLinks
    },
    props: ["clearance", "level"],
};
</script>

<style scoped>
.dashside {
  background-color: #263056c9;
  color: white;
  margin-top: 1px;
  height: 100%;
  padding-top: 10px;
  min-height: 70px;
  position: fixed;
  z-index: 999;
  width: 350px;  
  overflow-y: auto
}
.link-nav{
  overflow-y: auto
}
.dashtext {
  font-size: 25px;
  font-family: "Times New Roman", Times, serif;
  color: white;
}

.dashlink {
  display: flex;
  font-size: 20px;
  margin-top: 2rem;
  text-decoration: none;
  color: white;
  padding: 3px;
}
.active {
  border-right: 20px solid #263056;
  color: #263056;
}
.mactive {
  color: white;
  border-right:20px solid red;
}

@media screen and (min-width: 999px) {
  .sbb {
    display: none;
  }
}

@media (max-width: 999px) {
  .navbody {
    display: none;
  }
  .dashside{
    display: none
  }
}
</style>
